import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.function.bind";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-map";
import _classCallCheck from "/codebuild/output/src3842995830/src/www-public/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3842995830/src/www-public/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { genId, NodeType } from '../../../rrweb-snapshot/es/rrweb-snapshot.js';
import { EventType, IncrementalSource } from '../../../types/dist/rrweb-types.js';
import CrossOriginIframeMirror from './cross-origin-iframe-mirror.js';

var IframeManager = /*#__PURE__*/function () {
  function IframeManager(options) {
    _classCallCheck(this, IframeManager);

    this.iframes = new WeakMap();
    this.crossOriginIframeMap = new WeakMap();
    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
    this.crossOriginIframeRootIdMap = new WeakMap();
    this.mutationCb = options.mutationCb;
    this.wrappedEmit = options.wrappedEmit;
    this.stylesheetManager = options.stylesheetManager;
    this.recordCrossOriginIframes = options.recordCrossOriginIframes;
    this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
    this.mirror = options.mirror;

    if (this.recordCrossOriginIframes) {
      window.addEventListener('message', this.handleMessage.bind(this));
    }
  }

  _createClass(IframeManager, [{
    key: "addIframe",
    value: function addIframe(iframeEl) {
      this.iframes.set(iframeEl, true);
      if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
  }, {
    key: "addLoadListener",
    value: function addLoadListener(cb) {
      this.loadListener = cb;
    }
  }, {
    key: "attachIframe",
    value: function attachIframe(iframeEl, childSn) {
      var _a;

      this.mutationCb({
        adds: [{
          parentId: this.mirror.getId(iframeEl),
          nextId: null,
          node: childSn
        }],
        removes: [],
        texts: [],
        attributes: [],
        isAttachIframe: true
      });
      (_a = this.loadListener) === null || _a === void 0 ? void 0 : _a.call(this, iframeEl);
      if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
  }, {
    key: "handleMessage",
    value: function handleMessage(message) {
      var crossOriginMessageEvent = message;
      if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
      var iframeSourceWindow = message.source;
      if (!iframeSourceWindow) return;
      var iframeEl = this.crossOriginIframeMap.get(message.source);
      if (!iframeEl) return;
      var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
      if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
  }, {
    key: "transformCrossOriginEvent",
    value: function transformCrossOriginEvent(iframeEl, e) {
      var _this = this;

      var _a;

      switch (e.type) {
        case EventType.FullSnapshot:
          {
            this.crossOriginIframeMirror.reset(iframeEl);
            this.crossOriginIframeStyleMirror.reset(iframeEl);
            this.replaceIdOnNode(e.data.node, iframeEl);
            var rootId = e.data.node.id;
            this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
            this.patchRootIdOnNode(e.data.node, rootId);
            return {
              timestamp: e.timestamp,
              type: EventType.IncrementalSnapshot,
              data: {
                source: IncrementalSource.Mutation,
                adds: [{
                  parentId: this.mirror.getId(iframeEl),
                  nextId: null,
                  node: e.data.node
                }],
                removes: [],
                texts: [],
                attributes: [],
                isAttachIframe: true
              }
            };
          }

        case EventType.Meta:
        case EventType.Load:
        case EventType.DomContentLoaded:
          {
            return false;
          }

        case EventType.Plugin:
          {
            return e;
          }

        case EventType.Custom:
          {
            this.replaceIds(e.data.payload, iframeEl, ['id', 'parentId', 'previousId', 'nextId']);
            return e;
          }

        case EventType.IncrementalSnapshot:
          {
            switch (e.data.source) {
              case IncrementalSource.Mutation:
                {
                  e.data.adds.forEach(function (n) {
                    _this.replaceIds(n, iframeEl, ['parentId', 'nextId', 'previousId']);

                    _this.replaceIdOnNode(n.node, iframeEl);

                    var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);

                    rootId && _this.patchRootIdOnNode(n.node, rootId);
                  });
                  e.data.removes.forEach(function (n) {
                    _this.replaceIds(n, iframeEl, ['parentId', 'id']);
                  });
                  e.data.attributes.forEach(function (n) {
                    _this.replaceIds(n, iframeEl, ['id']);
                  });
                  e.data.texts.forEach(function (n) {
                    _this.replaceIds(n, iframeEl, ['id']);
                  });
                  return e;
                }

              case IncrementalSource.Drag:
              case IncrementalSource.TouchMove:
              case IncrementalSource.MouseMove:
                {
                  e.data.positions.forEach(function (p) {
                    _this.replaceIds(p, iframeEl, ['id']);
                  });
                  return e;
                }

              case IncrementalSource.ViewportResize:
                {
                  return false;
                }

              case IncrementalSource.MediaInteraction:
              case IncrementalSource.MouseInteraction:
              case IncrementalSource.Scroll:
              case IncrementalSource.CanvasMutation:
              case IncrementalSource.Input:
                {
                  this.replaceIds(e.data, iframeEl, ['id']);
                  return e;
                }

              case IncrementalSource.StyleSheetRule:
              case IncrementalSource.StyleDeclaration:
                {
                  this.replaceIds(e.data, iframeEl, ['id']);
                  this.replaceStyleIds(e.data, iframeEl, ['styleId']);
                  return e;
                }

              case IncrementalSource.Font:
                {
                  return e;
                }

              case IncrementalSource.Selection:
                {
                  e.data.ranges.forEach(function (range) {
                    _this.replaceIds(range, iframeEl, ['start', 'end']);
                  });
                  return e;
                }

              case IncrementalSource.AdoptedStyleSheet:
                {
                  this.replaceIds(e.data, iframeEl, ['id']);
                  this.replaceStyleIds(e.data, iframeEl, ['styleIds']);
                  (_a = e.data.styles) === null || _a === void 0 ? void 0 : _a.forEach(function (style) {
                    _this.replaceStyleIds(style, iframeEl, ['styleId']);
                  });
                  return e;
                }
            }
          }
      }
    }
  }, {
    key: "replace",
    value: function replace(iframeMirror, obj, iframeEl, keys) {
      var _iterator = _createForOfIteratorHelper(keys),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;

          if (Array.isArray(obj[key])) {
            obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
          } else {
            obj[key] = iframeMirror.getId(iframeEl, obj[key]);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return obj;
    }
  }, {
    key: "replaceIds",
    value: function replaceIds(obj, iframeEl, keys) {
      return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
  }, {
    key: "replaceStyleIds",
    value: function replaceStyleIds(obj, iframeEl, keys) {
      return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
  }, {
    key: "replaceIdOnNode",
    value: function replaceIdOnNode(node, iframeEl) {
      var _this2 = this;

      this.replaceIds(node, iframeEl, ['id', 'rootId']);

      if ('childNodes' in node) {
        node.childNodes.forEach(function (child) {
          _this2.replaceIdOnNode(child, iframeEl);
        });
      }
    }
  }, {
    key: "patchRootIdOnNode",
    value: function patchRootIdOnNode(node, rootId) {
      var _this3 = this;

      if (node.type !== NodeType.Document && !node.rootId) node.rootId = rootId;

      if ('childNodes' in node) {
        node.childNodes.forEach(function (child) {
          _this3.patchRootIdOnNode(child, rootId);
        });
      }
    }
  }]);

  return IframeManager;
}();

export { IframeManager };